var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c("el-collapse-transition", [
                _c("div", [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        background: "#f3f3f3",
                        height: "50px",
                        "line-height": "50px",
                        padding: "0 25px",
                        display: "flex",
                        "align-items": "center",
                        "justify-content": "space-between"
                      }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { placeholder: "分播类型" },
                          on: { change: _vm.setType },
                          model: {
                            value: _vm.type,
                            callback: function($$v) {
                              _vm.type = $$v
                            },
                            expression: "type"
                          }
                        },
                        _vm._l(_vm.types, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.name, value: item.value }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _vm.type == "wave_picking" && _vm.resData.is_show_4 > 0
                        ? _c("h1", { staticStyle: { "font-size": "36px" } }, [
                            _vm._v(
                              "\n              多件多波可用:" +
                                _vm._s(_vm.resData.gk_num_4) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type == "wave_picking" && _vm.resData.is_show_5 > 0
                        ? _c("h1", { staticStyle: { "font-size": "36px" } }, [
                            _vm._v(
                              "\n              多件少波可用:" +
                                _vm._s(_vm.resData.gk_num_5) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type == "pg" ||
                      _vm.type == "supply" ||
                      _vm.type == "summary"
                        ? _c("h1", { staticStyle: { "font-size": "36px" } }, [
                            _vm._v(
                              "\n              可用格口:" +
                                _vm._s(_vm.resData.gk_num) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.type == _vm.constantMap.hg
                        ? _c("h1", { staticStyle: { "font-size": "36px" } }, [
                            _vm._v(
                              "\n              空闲可用格口数:" +
                                _vm._s(_vm.freeGridCount) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { placeholder: "层数" },
                          on: { change: _vm.setFloor },
                          model: {
                            value: _vm.form.floor,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "floor", $$v)
                            },
                            expression: "form.floor"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: 0 }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "第一层", value: 1 }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "第二层", value: 2 }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.type == _vm.constantMap.hg
                        ? _c(
                            "el-select",
                            {
                              staticStyle: { width: "150px" },
                              attrs: { placeholder: "选择排序方式" },
                              on: { change: _vm.setSortType },
                              model: {
                                value: _vm.form.sort,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "sort", $$v)
                                },
                                expression: "form.sort"
                              }
                            },
                            _vm._l(_vm.constantMap.SORT_TYPES, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "primary", size: "mini" },
                          on: { click: _vm.refreshData }
                        },
                        [_vm._v("刷新页面")]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("最后刷新时间:" + _vm._s(_vm.resData.time))
                      ])
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.type == "wave_picking"
        ? _c(
            "div",
            { staticStyle: { "margin-bottom": "0", width: "100%" } },
            [
              _vm.resData.cut_data.length > 0
                ? _c("el-button", { attrs: { type: "primary", plain: "" } }, [
                    _vm._v("\n      拣货任务分播")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.resData.cut_data, function(item) {
                return _c("div", { key: item.cut_no }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "20%",
                        float: "left",
                        height: "10%",
                        margin: "0 auto",
                        "margin-left": "1%",
                        "margin-top": "10px",
                        border: "1px solid #3a8ee6",
                        "text-align": "center"
                      }
                    },
                    [
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [_vm._v("拣货单号:" + _vm._s(item.cut_no))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [
                            _vm._v(
                              "拣货方式:" +
                                _vm._s(item.assignment_type_text) +
                                " 波次类型:常规"
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [
                            _vm._v(
                              "已播/已拣/所需:" +
                                _vm._s(item.cut_num) +
                                "/" +
                                _vm._s(item.sm_num) +
                                "/" +
                                _vm._s(item.wave_picking_num)
                            )
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px"
                            }
                          },
                          [_vm._v(_vm._s(item.cut_time) + "/s")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "p",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "15px",
                                "margin-bottom": "15px"
                              },
                              attrs: { type: "success", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.showGrid(item.cut_no, 1)
                                }
                              }
                            },
                            [_vm._v("查看格口")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "15px"
                              },
                              attrs: { type: "danger", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.stopCut(item.cut_no, 1)
                                }
                              }
                            },
                            [_vm._v("结束分播")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type == "wave_picking"
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "0",
                width: "100%",
                float: "left",
                "margin-top": "20px"
              }
            },
            [
              _vm.resData.cut_data2.length > 0
                ? _c("el-button", { attrs: { type: "primary", plain: "" } }, [
                    _vm._v("\n      汇总分播")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.resData.cut_data2, function(item) {
                return _c("div", { key: item.cut_no }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "20%",
                        float: "left",
                        height: "10%",
                        margin: "0 auto",
                        "margin-left": "1%",
                        "margin-top": "10px",
                        border: "1px solid #3a8ee6",
                        "text-align": "center"
                      }
                    },
                    [
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [_vm._v("汇总号:" + _vm._s(item.cut_no))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [
                            _vm._v(
                              "拣货方式:" +
                                _vm._s(item.type_text) +
                                "汇总 波次类型:" +
                                _vm._s(item.type_text)
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [
                            _vm._v(
                              "已播/已拣/所需:" +
                                _vm._s(item.cut_num) +
                                "/" +
                                _vm._s(item.sm_num) +
                                "/" +
                                _vm._s(item.wave_picking_num)
                            )
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px"
                            }
                          },
                          [_vm._v(_vm._s(item.cut_time) + "/s")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "p",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "15px",
                                "margin-bottom": "15px"
                              },
                              attrs: { type: "success", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.showGrid(item.cut_no, 2)
                                }
                              }
                            },
                            [_vm._v("查看格口")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "15px"
                              },
                              attrs: { type: "danger", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.stopCut(item.cut_no, 2)
                                }
                              }
                            },
                            [_vm._v("结束分播")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type == "wave_picking"
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "0",
                width: "100%",
                float: "left",
                "margin-top": "20px"
              }
            },
            [
              _vm.resData.cut_data3.length > 0
                ? _c("el-button", { attrs: { type: "primary", plain: "" } }, [
                    _vm._v("\n      中分任务分播")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.resData.cut_data3, function(item) {
                return _c("div", { key: item.cut_no }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "20%",
                        float: "left",
                        height: "10%",
                        margin: "0 auto",
                        "margin-left": "1%",
                        "margin-top": "10px",
                        border: "1px solid #3a8ee6"
                      }
                    },
                    [
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [_vm._v("中分任务:" + _vm._s(item.cut_no))]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [
                            _vm._v(
                              "拣货方式:" +
                                _vm._s(item.picking_type) +
                                " 波次类型:" +
                                _vm._s(item.wave_type)
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("p", { staticClass: "box_p" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "left",
                              "margin-left": "15px"
                            }
                          },
                          [
                            _vm._v(
                              "已播/已拣/所需:" +
                                _vm._s(item.cut_num) +
                                "/" +
                                _vm._s(item.sm_num) +
                                "/" +
                                _vm._s(item.wave_picking_num)
                            )
                          ]
                        ),
                        _c(
                          "span",
                          {
                            staticStyle: {
                              float: "right",
                              "margin-right": "15px"
                            }
                          },
                          [_vm._v(_vm._s(item.cut_time) + "/s")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "p",
                        [
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "15px",
                                "margin-bottom": "15px"
                              },
                              attrs: { type: "success", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.showGrid(item.cut_no, 3)
                                }
                              }
                            },
                            [_vm._v("查看格口")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticStyle: {
                                float: "right",
                                "margin-right": "15px"
                              },
                              attrs: { type: "danger", size: "mini" },
                              on: {
                                click: function($event) {
                                  return _vm.stopCut(item.cut_no, 3)
                                }
                              }
                            },
                            [_vm._v("结束分播")]
                          )
                        ],
                        1
                      )
                    ]
                  )
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      ["pg", "supply", "summary"].includes(_vm.type)
        ? _c(
            "div",
            {
              staticStyle: {
                "margin-bottom": "0",
                width: "100%",
                background: "#6f7180"
              }
            },
            [
              _vm.resData.all_num
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "20%",
                          float: "left",
                          height: "10%",
                          margin: "0 auto",
                          "margin-left": "1%",
                          "margin-top": "10px",
                          border: "1px solid #3a8ee6",
                          "text-align": "center"
                        }
                      },
                      [
                        _c("h3", [
                          _c("p", { staticClass: "box_p" }, [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  float: "left",
                                  "margin-left": "15px"
                                }
                              },
                              [
                                _vm._v(
                                  "分播总数:" + _vm._s(_vm.resData.all_num)
                                )
                              ]
                            ),
                            _c("br")
                          ])
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "box_p" }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "15px"
                              }
                            },
                            [_vm._v("异常数量:" + _vm._s(_vm.resData.yc_num))]
                          ),
                          _c("br")
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "box_p" }, [
                          _c(
                            "span",
                            {
                              staticStyle: {
                                float: "left",
                                "margin-left": "15px"
                              }
                            },
                            [_vm._v("占用格口:" + _vm._s(_vm.resData.grid_num))]
                          ),
                          _c("br")
                        ]),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "box_p" },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  float: "left",
                                  "margin-left": "15px"
                                }
                              },
                              [_vm._v(_vm._s(_vm.resData.cut_time) + "/s")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                staticStyle: {
                                  float: "right",
                                  "margin-right": "15px",
                                  "margin-bottom": "10px"
                                },
                                attrs: { type: "danger", size: "mini" },
                                on: {
                                  click: function($event) {
                                    return _vm.stopCut("", 0)
                                  }
                                }
                              },
                              [_vm._v("结束分播")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === _vm.constantMap.hg
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticStyle: { "padding-bottom": "12px" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function($event) {
                          return _vm.handleEndGrid()
                        }
                      }
                    },
                    [_vm._v("\n        结束全部分播\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleBatchEndGrid()
                        }
                      }
                    },
                    [_vm._v("\n        批量结束分播\n      ")]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { gutter: 8 } },
                _vm._l(_vm.resData, function(item) {
                  return _c(
                    "el-col",
                    {
                      key: item.grid_id,
                      staticStyle: { "margin-bottom": "8px" },
                      attrs: { md: 8, lg: 6, xl: 4 }
                    },
                    [
                      _c(
                        "el-card",
                        {
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c(
                                      "el-row",
                                      {
                                        attrs: {
                                          type: "flex",
                                          justify: "space-between",
                                          align: "bottom"
                                        }
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "bold"
                                            }
                                          },
                                          [
                                            _c(
                                              "el-checkbox",
                                              {
                                                attrs: { label: item.grid_id },
                                                model: {
                                                  value: _vm.gridIds,
                                                  callback: function($$v) {
                                                    _vm.gridIds = $$v
                                                  },
                                                  expression: "gridIds"
                                                }
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "none"
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(item.grid_id))]
                                                )
                                              ]
                                            ),
                                            _vm._v(_vm._s(item.grid_no))
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: { "font-size": "14px" }
                                          },
                                          [_vm._v(_vm._s(item.cut_time) + "/s")]
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(" "),
                          item.is_single_grid === "1"
                            ? _c(
                                "div",
                                { staticStyle: { "padding-bottom": "12px" } },
                                [
                                  _vm._v(
                                    "\n            单件格口:\n            " +
                                      _vm._s(item.surpass_summary_id) +
                                      "\n          "
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                { staticStyle: { "padding-bottom": "12px" } },
                                [
                                  _vm._v(
                                    "\n            中分编码:" +
                                      _vm._s(item.hg_code) +
                                      " " +
                                      _vm._s(item.hg_show_id) +
                                      "-" +
                                      _vm._s(item.the_sort) +
                                      "\n          "
                                  )
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { "padding-bottom": "12px" } },
                            [_vm._v("已播: " + _vm._s(item.cut_num) + "件")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            {
                              attrs: { type: "flex", justify: "space-between" }
                            },
                            [
                              item.is_single_grid !== "1"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success", size: "small" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showGrid(
                                            "",
                                            4,
                                            item.grid_id
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              查看格口\n            "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "danger", size: "small" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleEndGrid(item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              结束分播\n            "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "详情", visible: _vm.girdVisible },
          on: {
            "update:visible": function($event) {
              _vm.girdVisible = $event
            }
          }
        },
        [
          _c(
            "el-table",
            { attrs: { data: _vm.infoDetail } },
            [
              _c("el-table-column", {
                attrs: {
                  property: "wave_picking_no",
                  label: "波次号",
                  align: "center",
                  width: "150"
                }
              }),
              _vm._v(" "),
              _vm.type !== _vm.constantMap.hg
                ? _c("el-table-column", {
                    attrs: {
                      property: "grid_no",
                      label: "格口",
                      align: "center",
                      width: "120"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "cut_dbids", label: "打标ID" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c_page-title" }, [
      _c("div", [_vm._v("波次分播")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d3f2f51", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d3f2f51","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/DeviceCut.vue
// module id = null
// module chunks = 